<template>
    <div>
        <!--提示标题栏-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
                用户参与设置
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 35%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                用户参与设置
            </div>
        </div>
        <!--可输入信息-->
        <el-form  :model="ecxForm" ref="ecxForm"
                  label-width="150px" class="demo-ruleForm"  >
            <el-form-item label="用户等级" prop="userLevel" >
                <el-select v-model="ecxForm.userLevel" placeholder="用户等级"
                           style="width: 35%;" :disabled="isCheckStatus">
                    <el-option label="所有用户" value="0" >所有用户</el-option>
                    <el-option label="普通用户" value="1" >普通用户</el-option>
                    <el-option label="黄金用户" value="2" >黄金用户</el-option>
                    <el-option label="白金用户" value="3" >白金用户</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="参与次数" prop="participateNumber">
                <el-select v-model="ecxForm.participateNumber" placeholder="参与次数"
                           style="width: 35%;" :disabled="isCheckStatus">
                    <el-option label="无限制" value="0" >无限制</el-option>
                    <el-option label="一天一次" value="1" >一天一次</el-option>
                    <el-option label="活动期间仅一次" value="2" >活动期间仅一次</el-option>
                    <el-option label="活动期间多次" value="3" >活动期间多次</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关注公众号" prop="diyihh">
                <el-select v-model="ecxForm.diyihh" placeholder="关注公众号"
                           style="width: 35%;" :disabled="isCheckStatus">
                    <el-option label="无限制" value="0" >无限制</el-option>
                    <el-option label="必须关注公众号" value="1" >必须关注公众号</el-option>
                    <el-option label="必须关注店铺" value="2" >必须关注店铺</el-option>
                </el-select>
            </el-form-item>
            <!--上一步按钮 下一步按钮-->
            <el-form-item style="margin-left: 16.5%">
                <el-button type="primary" @click="lastStep('ecxForm')"
                           id="last_step" :disabled="isorgsubmit">上一步
                </el-button>

                <el-button type="primary" @click="nextStep('ecxForm')"
                           id="next_step" :disabled="isorgsubmit">下一步
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "CheckCondition",
        props:["actID","status"],
        data() {
            return {
                isexpSecond: false,
                isorgsubmit: false,
                isCheckStatus:true,
                ecxForm: {
                    userLevel: '0',
                    participateNumber: '0',
                    diyihh: '0',
                },
            }
        },
        created(){

        },
        methods: {
            /*卡片跳转*/
            sendMsgToParent:function (step,id) {
                this.$emit("listenToChildEvent",step,id)
            },
            nextStep(formName){
                console.log("条件："+this.actID)
                this.sendMsgToParent("3",this.actID)
            },
            lastStep(formName){
                this.sendMsgToParent("1",this.actID)
            },
        }
    }
</script>

<style scoped>
    .demo-ruleForm {
        margin: 20px auto 0 auto;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// ChoiceCondition.vue?401da208